<template>
  <div class="applications-layout">
    <van-tabs v-model="activeMenuName" class="applications-tab-menu">
      <van-tab
        title-class="applications-tab"
        :title="$t(`${i18nPrefix}.label.completedApplication`)"
        :name="COMPLETED_APPLICATION"
        :to="getCompleteApplicationRoute()"
      ></van-tab>
      <van-tab
        :title="$t(`${i18nPrefix}.label.incompleteApplication`)"
        :name="INCOMPLETE_APPLICATION"
        :badge="pendingApplicationCount"
        :to="getIncompleteApplicationRoute()"
      ></van-tab>
    </van-tabs>
    <div class="applications-content">
      <router-view
        :personalInfo="personalInfo"
      />
    </div>
  </div>
</template>

<script>
import * as applicationsRoute from '../../applicationsRoute'
import mixin from '@/views/personalNew/home/mixin'
import { COMPLETED_APPLICATION, INCOMPLETE_APPLICATION } from '@/constant/application'

export default {
  props: {
    personalInfo: {
      required: true
    }
  },
  mixins: [mixin],
  data () {
    return {
      COMPLETED_APPLICATION,
      INCOMPLETE_APPLICATION,
      applicationsRoute,
      i18nPrefix: 'personal.applications',
      activeMenuName: COMPLETED_APPLICATION
    }
  },
  computed: {
    pendingApplicationCount () {
      if (!this.personalInfo || !this.personalInfo.pending_application_count) {
        return null
      }
      return this.personalInfo.pending_application_count
    }
  },
  created () {
    this.activeMenuName = this.$route.meta.applicationStatus
  },
  methods: {
    getCompleteApplicationRoute () {
      return {
        path: applicationsRoute.personalCompleteApplicationRoute.path,
        query: {
          ...this.$route.query
        }
      }
    },
    getIncompleteApplicationRoute () {
      return {
        path: applicationsRoute.personalIncompleteApplicationRoute.path,
        query: {
          ...this.$route.query
        }
      }
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
.applications-layout {
  .applications-tab-menu {
    ::v-deep {
      .van-tabs__wrap {
        height: initial;
        overflow: initial;

        .van-tabs__nav {
          background-color: initial;

          .van-tab {
            display: block;
            color: #aaa;
            font-size: 16px;
            padding: 8px 24px;
            text-align: center;

            .van-tab__text-wrapper {
              display: inline;
            }

            .van-tab__text--ellipsis {
              display: inline;
              -webkit-line-clamp: initial;
            }

            &.applications-tab {
              border-right: 1px solid #aaa;
            }

            &.van-tab--active {
              color: #333;
              font-weight: normal;
            }

            .van-info {
              top: -6px;
              right: -8px;
              background-color: var(--custom-color, #0096cc);
            }
          }
        }

        .van-tabs__nav--line {
          padding-bottom: 0;
        }

        .van-tabs__line {
          background-color: var(--custom-color, #0096cc);
          bottom: 0;
        }
      }
    }
  }

  .applications-content {
    margin-top: 24px;
    padding: 0 20px;
  }
}
</style>
